import { errorToast } from "iparque-components";
import { entityLogin } from "api/authentication";
import { UrlParams, Options } from "api/interfaces";
import { Entity } from "interfaces/entities";
import { buildQueryString } from "api/helper";

export const redirectLogin = async (
  { entityToken }: Entity,
  authToken: string,
  { t, stopLoading }: Options = {},
  extraParams: UrlParams = {}
): Promise<Entity | undefined> => {
  if (!entityToken && t) {
    errorToast(
      t("7847") /* Erro! */,
      t("10937") /* Ocorreu um erro ao escolher a concessionária. */
    );

    return undefined;
  }

  const { data } = await entityLogin(entityToken, authToken);

  if (data) {
    const { url, userId, hash } = data;

    if (url && userId && hash) {
      const extraParamsString = buildQueryString(extraParams);
      const urlRedirect = `${url}&op=LoginHash&idUtilizador=${userId}&hash=${hash}&${extraParamsString}`;

      window.location.replace(urlRedirect);
    } else if (t && stopLoading) {
      stopLoading();

      errorToast(
        t("7847") /* Erro! */,
        t("10937") /* Ocorreu um erro ao escolher a concessionária. */
      );
    }
  }

  return data;
};
